import PropTypes from "prop-types";
import { Ban, Ellipsis, RefreshCw } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";

export function ApiKeysTableActions({ original, onRotate, onRevoke }) {
  const canRotate = useAuthorized([ACL_RELATIONSHIPS.adminApiKeys.edit]);
  const canRevoke = useAuthorized([ACL_RELATIONSHIPS.adminApiKeys.delete]);
  const isRevoked = !!original.revoked_at;

  if (!canRotate && !canRevoke) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="API key actions"
        className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
      >
        <Ellipsis />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {canRotate && (
          <DropdownMenuItem
            disabled={isRevoked}
            onClick={() => onRotate(original)}
          >
            <RefreshCw />
            Rotate
          </DropdownMenuItem>
        )}
        {canRevoke && (
          <DropdownMenuItem
            variant="destructive"
            disabled={isRevoked}
            onClick={() => onRevoke(original)}
          >
            <Ban />
            Revoke
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

ApiKeysTableActions.propTypes = {
  original: PropTypes.shape({
    id: PropTypes.number.isRequired,
    revoked_at: PropTypes.string,
  }).isRequired,
  onRotate: PropTypes.func.isRequired,
  onRevoke: PropTypes.func.isRequired,
};
